import { LoadingSpin } from "./icons"

const SpinLoader = () => (
  <div className="h-5 w-5 flex justify-center items-center mr-2">{LoadingSpin}</div>
)

export default SpinLoader
